module.exports = __webpack_public_path__ + "img/banner-2-1@1x.58d27de0.jpg";